
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.8 88.5c-2.9 3.7-7.4 6-12.4 6-8.7 0-15.8-7.1-15.8-15.8 0-8.7 7.1-15.8 15.8-15.8 4.7 0 9 2.1 11.9 5.4l5.9-7.5c-4.6-4.6-10.9-7.4-17.8-7.4C11.3 53.4 0 64.7 0 78.7S11.3 104 25.3 104c7 0 13.3-2.8 17.9-7.4l-5.4-8.1zM48.3 54.4H59v49.1H48.3zM106.6 54.6h10.7v49.1h-10.7zM88.3 104c-9.2 0-11.4-7.8-11.6-12.3h-.1v-28h-9.4v-9h9.4v-9.5l9.5-5.8-.3 7.3v8h9.6v9h-9.6v24.9c-.1.3-.1.7-.1 1.1s0 .7.1 1.1v.6c.4 2.2 1.8 4 3.8 4.8.8.3 1.6.5 2.5.5 2 0 3.8-.9 5-2.3.3-.3.5-.7.7-1 .1-.3.3 10.6-9.5 10.6z"}}),_c('path',{attrs:{"d":"M85.9 88.5v2.1c-.1-.3-.1-.7-.1-1.1 0-.3 0-.7.1-1zM84.5 23.9c-18.1 0-34.2 9.2-43.5 23.2h15.1c7.3-7.1 17.3-11.6 28.3-11.6s21 4.4 28.3 11.6H128c-9.3-13.8-25.3-23.2-43.5-23.2z"}})])
          )
        }
      }
    